// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".options[data-v-156a8390]{display:flex;flex-wrap:wrap;justify-content:center;gap:10px 50px}.paylater[data-v-156a8390],.paynow[data-v-156a8390],.redemption[data-v-156a8390]{flex:0 1 35em;display:flex;flex-direction:column;justify-content:space-between;gap:20px}.link-button[data-v-156a8390]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
